import AXIOS from '@/axios-instance';

export default {

  addRole(roleTitle) {
    return AXIOS.post("/role", roleTitle);
  },
  retrieveRoles(){
    return AXIOS.get("/role");
  },
  deleteRole(roleId){
    return AXIOS.delete("/role/"+roleId);
  }
}